import React from "react";

const Card = ({ cardType, img, title, click, isClaimed }) => {
  return (
    <>
      {cardType === "insideHeading" ? (
        <div
          className={`group relative rounded-2xl overflow-hidden mb-3 bg-white shadow-md ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${click ? "cursor-pointer" : ""}`}
          onClick={click ? click : undefined}
        >
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <img
              src={img}
              alt=""
              className="w-full h-full object-fill transition-transform duration-500 group-hover:scale-110"
            />
          </div>

          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent px-3 py-3 text-white">
            <p className="mb-0 text-center font-semibold">{title}</p>
          </div>
        </div>
      ) : (
        <div
          className={`group relative rounded-2xl overflow-hidden mb-3 bg-white shadow-md ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${click ? "cursor-pointer" : ""}`}
          onClick={click ? click : undefined}
        >
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <img
              src={img}
              alt=""
              className="w-full h-full object-fill transition-transform duration-500 group-hover:scale-110"
            />
          </div>

          {isClaimed && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white text-xl font-bold">
              Claimed
            </div>
          )}
          {title && (
            <div className="px-3 py-3 text-black">
              <p className="mb-0 text-left font-medium line-clamp-1">{title}</p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Card;
